
const IDENTIFIER = 'home';

const UsersService = {

  setHomePage (homepage) {
    window.localStorage.setItem(IDENTIFIER, homepage)
  },

  getHomePage () {
    return window.localStorage.getItem(IDENTIFIER)
  }

}

export default UsersService
